export const attendanceGroupRouting = [
  {
    path: "/attendance/attendanceGroup/list",
    name: "attendance-attendanceGroup-list",
    meta: { title: "考勤组管理" },
    component: () =>
      import(/* webpackChunkName: "attendance-attendanceGroup" */ "@/views/attendance-management/attendance-group-management/list/list.vue"),
  },
	{
		hidden:true,
	  path: "/attendance/attendanceGroup/create",
	  name: "attendance-attendanceGroup-create",
	  meta: { title: "新建考勤组" },
	  component: () =>
	    import(/* webpackChunkName: "attendance-attendanceGroup" */ "@/views/attendance-management/attendance-group-management/form/form.vue"),
	},
	{
		hidden:true,
	  path: "/attendance/attendanceGroup/edit/:id",
	  name: "attendance-attendanceGroup-edit",
	  meta: { title: "编辑考勤组" },
	  component: () =>
	    import(/* webpackChunkName: "attendance-attendanceGroup" */ "@/views/attendance-management/attendance-group-management/form/form.vue"),
	},
	// {
	// 	hidden:true,
	//   path: "/attendance/attendanceGroup/detail/:id",
	//   name: "attendance-attendanceGroup-detail",
	//   meta: { title: "考勤组管理详情" },
	//   component: () =>
	//     import(/* webpackChunkName: "attendance-attendanceGroup" */ "@/views/attendance-management/attendance-group-management/detail/detail.vue"),
	// },
]